import CompletedCallParticipantList from "../academic/examinations/callParticipantList/completed";
import SummerCampAddCategory from "../academic/examinations/SummerCampCategories.tsx/addCategorySummerCamp";
import WizklubOneYearPreviousYearStudents from "../academic/examinations/wizklubPreviousYearPaidStudents/previous";
import AdminDashboard from "../mainMenu/adminDashboard";

export const all_routes = {
  // Master
  callParticipantImport: "/academic/examinations/call-participant/import",
  prismOverAllCallLogs: "/academic/prisam/overall-call-logs", 
  prismAgentCallSummary: "/academic/prisam/agent-call-summary",
  prismAgentWiseCallLog: "/academic/prisam/agent-wise-call-logs",
  prismHourlyReport: "/academic/prisam/hourly-report",
  prismLeadsUpload: "/academic/prisam/leads/import",
  prismAddOrUpdateTicket: "/academic/prisam/leads/addOrUpdateTicket",
  addPrismLead: "/academic/prisam/leads/add",
  editPrismLead: "/academic/prisam/leads/edit",
  prismPendingLeads: "/academic/prisam/leads/pending",
  prismCompletedLeads: "/academic/prisam/leads/completed",
  prismTeamManagement: "/academic/prism/team-management",
  prismAddTeamManagement: "/academic/prism/team-management/add",
  prismEditTeamManagement: "/academic/prism/team-management/edit",
  prisamCategories: "/academic/prisam/categories",
  prisamAddCategories: "/academic/prisam/categories/add",
  prisamEditCategories: "/academic/prisam/categories/edit",
  prisamSubCategories: "/academic/prisam/sub-categories",
  prisamAddSubCategories: "/academic/prisam/sub-categories/add",
  prisamEditSubCategories: "/academic/prisam/sub-categories/edit",
  wizklubDailySalesTaarget: "/academic/wizklub/wizklubDailySales",
  AddWizklubDailySalesTaarget: "/academic/wizklub/wizklubDailySales-add",
  EditWizklubDailySalesTaarget: "/academic/wizklub/wizklubDailySales-edit",
  wizklubOneYearPreviousYearStudents: "/academic/examinations/wizklubPreviousYearPaidStudents/previous",
  adminDashboard1: "/",
  CompletedCallParticipantList: "/academic/examinations/call-participant/completed",
  smstoStudent: "/academic/examinations/sms-to-student",
  pendingEmployeeDetails: "/academic/employee/pending-details",
  completedEmployeeDetails: "/academic/employee/completed-details",
  employeeWorkAssignment: "/academic/employee/work-assignment",
  addEmployeeWorkAssignment: "/academic/employee/work-assignment/add",
  editEmployeeWorkAssignment: "/academic/employee/work-assignment/edit",
  metaEmployeeLoginDetailsUpload: "/academic/meta-login-details-upload",
  scoreReports: "/academic/score/reports",
  teacherRole: "/academic/teacher/role",
  addTeacherRole: "/academic/teacher/add-role",
  editTeacherRole: "/academic/teacher/edit-role",
  addBranchAssignment: "/academic/examinations/score/employeeBranchAssignment/add",
  editBranchAssignment: "/academic/examinations/score/employeeBranchAssignment/edit",
  employeeBranchAssignment: "/academic/examinations/score/employeeBranchAssignment",
  scoreEmployeeBranches: "/academic/examinations/score/scoreBranchesForEmployees",
  scoreDailedEmployeeBranches: "/academic/examinations/score/scoreBranchesForDailedEmployees",
  scoreEmployeeDetails: "/academic/examinations/score/scoreEmployees",
  scoreDailedEmployeeDetails: "/academic/examinations/score/scoreDailedEmployees",
  addDispositions: "/academic/wizklub/adddispositons",
  editDispositions: "/academic/wizklub/editdispositons",
  dispositions: "/academic/wizklub/dispositons",
  addCategories: "/academic/wizklub/addcategories",
  editCategories: "/academic/wizklub/editcategories",
  categories: "/academic/wizklub/categories",
  addSubCategories: "/academic/wizklub/addsubCategories",
  editSubCategories: "/academic/wizklub/editsubCategories",
  subCategories: "/academic/wizklub/subCategories",
  addPriorities: "/academic/wizklub/addpriorities",
  editPriorities: "/academic/wizklub/editpriorities",
  priorities: "/academic/wizklub/priorities",
  addTicketStatus: "/academic/wizklub/addticketStatus",
  editTicketStatus: "/academic/wizklub/editticketStatus",
  ticketStatus: "/academic/wizklub/ticketStatus",
  TypeOfTicket: "/academic/wizklub/typeOfTicket",
  addTypeOfTicket: "/academic/wizklub/addTypeOfTicket",
  editTypeOfTicket: "/academic/wizklub/editTypeOfTicket",
  addWizklubTicket: "/academic/wizklub/addWizklubTicket",
  editWizklubTicket: "/academic/wizklub/editWizklubTicket",
  wizklubView: "/acdemic/wizklub/wizklubView",
  SummerCampCategories: "/academic/summerCamp/SummerCampCategories",
  SummerCampAddCategories: "/academic/summerCamp/SummerCampAddCategories",
  SummerCampEditCategories: "/academic/summerCamp/SummerCampEditCategories",
  SummerCampDisposition: "/academic/summerCamp/SummerCampDisposition",
  SummerCampAddDisposition: "/academic/summerCamp/SummerCampAddDisposition",
  SummerCampEditDisposition: "/academic/summerCamp/SummerCampEditDisposition",
  SummerCampSubCategories: "/academic/summerCamp/SummerCampSubCategories",
  SummerCampAddSubCategories: "/academic/summerCamp/SummerCampAddSubCategories",
  SummerCampEditSubCategories: "/academic/summerCamp/SummerCampEditSubCategories",
  SummerCampPriorities: "/academic/summerCamp/SummerCampPriorities",
  SummerCampAddPriorities: "/academic/summerCamp/SummerCampAddPriorities",
  SummerCampEditPriorities: "/academic/summerCamp/SummerCampEditPriorities",
  SummerCampTicketStatus: "/academic/summerCamp/SummerCampTicketStatus",
  SummerCampAddTicketStatus: "/academic/summerCamp/SummerCampAddTicketStatus",
  SummerCampEditTicketStatus: "/academic/summerCamp/SummerCampEditTicketStatus",
  SummerCampStudents: "/academic/summerCamp/summerCampStudents",
  SummerCampAddTicket: "/academic/summerCamp/summerCampAddTicket",
  SummerCampUpdateTicket: "/academic/summerCamp/summerCampEditTicket",
  SummerCampPendingEnrollments: "/academic/summerCamp/pendingEnrollments",
  profile: "/academic/summerCamp/userProfie",
  agentCallSummary: "/academic/summerCamp/agentCallSummary",
  agentWiseCallLogs: "/academic/summerCamp/agentWiseCallLogs",
  agentWiseTargetStatus: "/academic/summerCamp/agentWiseTargetStatus",
  agentWiseStudentStatus: "/academic/summerCamp/agentWiseStudentStatus",
  activity: "/academic/summerCamp/activities",
  agentTargets: "/academic/summerCamp/agentTargets",
  SummerCampCallBacks: "/academic/summerCamp/summerCampCallBacks",
  summeerCampAddTargetTicket: "/academic/summerCamp/addTargetTicket",
  summerCampEditTargetTicket: "/academic/summerCamp/editTargetTicket",
  summerCampAddCallBackTicket: "/academic/summerCamp/addCallBackTicket",
  summerCampEditCallBackTicket: "/academic/summerCamp/editCallBackTicket",
  BranchesWizclubOrnot: "/academic/summerCamp/branchesWizclubOrNot",
  leaderboard: "/academic/summerCamp/leaderboard",
  agentWiseStudentSales: "/academic/summerCamp/agentWiseStudentSales",
  teamManagementList: "/academic/summerCamp/teamManagementList",
  addTeamManagement: "/academic/summerCamp/addTeamManagement",
  editTeamManagement: "/academic/summerCamp/editTeamManagement",
  agentGroupTypesList: "/academic/summerCamp/agentGroupTypesList",
  addAgentGroupTypes: "/academic/summerCamp/addAgentGroupTypes",
  editAgentGroupTypes: "/academic/summerCamp/editAgentGroupTypes",
  agentGroupsList: "/academic/summerCamp/agentGroupsList",
  addAgentGroups: "/academic/summerCamp/addAgentGroups",
  editAgentGroups: "/academic/summerCamp/editAgentGroups",
  summerCampCompletedTargets: "/academic/summerCamp/completedTargets",
  wizklubCategories: "/wizklub/categories",
  wizklubAddCategories: "/wizklub/addCategory",
  wizklubEditCategories: "/wizklub/editCategory",
  wizklubSubCategories: "/wizklub/SubCategories",
  wizklubAddSubCategories: "/wizklub/addSubCategory",
  wizklubEditSubCategories: "/wizklub/editSubCategory",
  wizklubStudents: "/wizklub/students",
  addOrUpdateWizklubTicket: "/wizklub/addOrUpdateTicket",
  wizklubCallBacks: "/wizklub/callbacks",
  addOrUpdateWizklubCallBackTicket: "/wizklub/addOrUpdateCallBackTicket",
  summercampBranchesManager: "/academic/summerCamp/summerCampBranches",
  wizklubBranchesManager: "/academic/wizklub/BranchesManager",
  wizklubBranchesTeamLead: "/academic/wizklub/BranchesTeamLead",
  NonChaiatnyaSummerCampStudents: "/academic/summerCamp/nonChaitanyaStudents",
  NonChaitanyaAgentTargets: "/academic/summerCamp/nonChaitanyaAgentTargets",
  NonChaitanyaSummerCampCallBacks: "/academic/summerCamp/nonChaitanyaCallBacks",
  NonChaitanyaSummerCampCompletedTargets: "/academic/summerCamp/nonChaitanyaCompletedTargets",
  NonChaitanyaSummerCampTicket: "/academic/summerCamp/nonChaitanyaTicket",
  NonChaitanyaSummerCampTargetTicket: "/academic/summerCamp/nonChaitanyaTargetTicket",
  NonChaitanyaSummerCampCallBackTicket: "/academic/summerCamp/nonChaitanyaCallBackTicket",
  wizklubPreviousYearPaidStudents: "/academic/wizklub/previousYearPaidStudents",
  wizklubCompletedStudents: "/academic/wizklub/completedStudents",
  wizklubAgentCallSummary: "/academic/wizklub/agentCallSummary",
  wizklubAgentWiseCallLogs: "/academic/wizklub/agentWiseCallLogs",
  wizklubSales: "/academic/wizklub/sales",
  wizklubDashboard: "/academic/admin-dashboard1",
  wizklubHourlyReport: "/academic/wizklub/hourly-report",
  phoneNumberToStudent: "/academic/crm/phoneNumberToStudent",
  summerCampTeamLeadBranches: "/academic/summerCamp/teamLeadBranches",
  wizklubSalesDisplay: "/academic/wizklub/salesDisplay",
  summmerCampHourlyReport: "/academic/summercamp/hourlyReport",
  wizklubAgentsAttendance: "/academic/wizklub/agents-attendance",
  wizklubBranchWiseSaleData: "/academic/wizklub/branch_wise_sale_data",
  wizklubBranchWiseConnectedData: "/academic/wizklub/branch_wise_connected_data",
  wizklubBranchWiseIntrestedata: "/academic/wizklub/branch_wise_intrested_data",
  wizklubBranchWiseCallBackData: "/academic/wizklub/branch_wise_callBack_data",
  wizklubBranchWiseNotIntrestedData: "/academic/wizklub/branch_wise_not_intrested_data",
  NonChaitanyaCategories: "/academic/NonChaitanya/Categories",
  NonChaitanyaAddCategories: "/academic/NonChaitanya/AddCategories",
  NonChaitanyaEditCategories: "/academic/NonChaitanya/EditCategories",
  NonChaitanyaSubCategories: "/academic/NonChaitanya/SubCategories",
  NonChaitanyaAddSubCategories: "/academic/NonChaitanya/AddSubCategories",
  NonChaitanyaEditSubCategories: "/academic/NonChaitanya/EditSubCategories",
  NonChaitanyaAgentCallSummary: "/academic/NonChaitanya/agentCallSummary",
  NonChaitanyaAgentWiseCallLogs: "/academmic/nonChaitanya/agentWiseCallLogs",
  NonChaitanyaHourlyReport: "/academic/nonChaiatanya/hourlyReport",
  NonChaitanyaSales: "/academic/nonChaitanya/sales",
  SummerCampTelanganaStudents: "/academic/SummerCammp/TelanganaStudents",
  wizklubAgentReports: "/academic/wizklub/agentReports",
  wizklubAgentBranchReports: "/academic/wizklub/branchReports",
  SummerCampAgentReports: "/academic/SummerCamp/agentReports",
  SummerCampAgentBranchReports: "/academic/SummerCamp/branchReports",
  wizklubCallLogs: "/academic/wizklub/callLogs",
  summercampCallLogs: "/cademic/summercamp/callLogs",
  nonChaitanyaCallLogs: "/academic/nonChaitanya/callLogs",
  callParticipantCategories: "/academic/call-participant/categories",
  callParticipantAddCategory: "/academic/call-participant/categories/add",
  callParticipantEditCategory: "/academic/call-participant/categories/edit",
  callParticipantSubCategories: "/academic/call-participant/sub-categories",
  addCallParticipantSubCategories: "/academic/call-participant/sub-categories/add",
  editCallParticipantSubCategories: "/academic/call-participant/sub-categories/edit",
  callParticipantList: "/academic/call-participant/list",
  addCallParticipant: "/academic/call-participant/add",
  editCallParticipant: "/academic/call-participant/edit",
  callParticipantAgentCallSummary: "/academic/call-participant/agent-call-summary",
  callParticipantAgentWiseCallLog: "/academic/call-participant/agent-wise-call-logs",
  callParticipantHourlyReport: "/academic/call-participant/hourly-report",
  callParticipantcallLogs: "/academic/call-participant/call-logs",
  addOrUpdateCallParticipantTicket: "/academic/call-participant/addOrUpdate",
  summercampScAndNonScAgentCallSummary: "/academic/SummerCamp/ScAndNonScAgentCallSummary",
  summercampScAndNonScAgentWiseCallLogs: "/academic/SummerCamp/ScAndNonScAgentWiseCallLogs",
  employeeBranches: "/academic/Employee/branches",
  employeeDetails: "/academic/Employee/details",
  employeeCategories: "/academic/employee/Categories",
  employeeAddCategories: "/academic/employee/AddCategories",
  employeeEditCategories: "/academic/employee/EditCategories",
  employeeSubCategories: "/academic/employee/SubCategories",
  employeeAddSubCategories: "/academic/employee/AddSubCategories",
  employeeEditSubCategories: "/academic/employee/EditSubCategories",
  addOrUpdateEmployeeTicket: "/academic/employee/addOrUpdateTicket",
  employeeAgentCallSummary: "/academic/employee/agent-call-summary",
  employeeAgentWiseCallLog: "/academic/employee/agent-wise-call-logs",
  employeeHourlyReport: "/academic/employee/hourly-report",
  employeecallLogs: "/academic/employee/call-logs",
  employeeServiceDivision: "/academic/employee/servicee-division",
  employeeAddServiceDivision: "/academic/employee/add-service-division",
  employeeEditServiceDivision: "/academic/employee/edit-employee-service-division",
  wizklubTrainerBranches: "/academic/wizklub/trainer-branches",
  wizklubTrainerStudents: "/academic/wizklub/trainer-students",
  employeeUserProfile: "/academic/employee/user-profile",
  employeeUsers: "/academic/employee/users",
  employeeTeamManagment: "/academic/employee/teams",
  addEmployeeTeamManagment: "/academic/employee/Team/add",
  editEmployeeTeamManagment: "/academic/employee/team/edit",
  wizklubInputs: "/academic/wizklub/inputs",
  WizklubAgentWiseBranchInputs: "/academic/wizklub/inputs/agent-wise-branch",
  WizklubCallsConnected: "/academic/wizklub/inputs/calls-connected",
  WizklubCallsGreaterThan1Minute30Seconds: "/academic/wizklub/inputs/calls-greater-than-1-minute-30-seconds",
  WizklubCallLessThan1Minute: "/academic/wizklub/inputs/calls-less-than-1-minute",
  WizklubCallLessThan1Minute30Seconds: "/academic/wizklub/inputs/calls-less-than-1-minute-30-seconds",
  WizklubCallLessThan30Seconds: "/academic/wizklub/inputs/calls-less-than-30-seconds",
  WizklubNoOfCallsInputs: "/academic/wizklub/inputs/no-of-calls",
  WizklubUniqueLeadTouchInputs: "/academic/wizklub/inputs/unique-lead-touch",
  WizklubUniqueLeadTouchConnectedInputs: "/academic/wizklub/inputs/unique-lead-touch-connected",
  crmLandingPage: "/academic/sri-chaitanya/crm/landing-page",
  employeeDailed: "/academic/employee/dailed",
  wizklubTrainerFollowUpBranches: "/academic/wizklub/trainer/followp-branches",
  wizklubTrainerFollowUpStudents: "/academic/wizklub/trainer/followup-students",
  wizklubTrainerDailedBranches: "/academic/wizklub/trainer/dailed-branches",
  wizklubTrainerDailedStudents: "/academic/wizklub/trainer/dailed-students",
  wizklubBranchUniqueLeadTouch: "/academic/wizklub/branch-unique-lead-touch",
  seminors: "/academic/seminor/seminor-list",
  addSeminor: "/academmic/seminor/add-seminor",
  editSeminor: "/academic/seminor/edit-seminor",
  wizklubBranchCvr: "/academic/wizklub/branch-cvr",
  wizklubAssignBranchTarget: "/academic/wizklub/assign-branch-target",
  wizklubAssignBranchCategory: "/academic/wizklub/assign-branch-category",
  wizklubWeeklySales: "/academic/wizklub/weekly-sales",
  addTargetForWizklubWeeklySales: "/academic/wizklub/add-target-for-weekly-sales",
  editTargetForWeeklySales: "/academic/wizklub/edit-target-forweekly-sales",
  wizklubTrainerSales: "/academic/wizklub/trainer-sales",
  wizklubDailyTargets: "/academic/wizklub/daily-targets",
  addWizklubDailyTarget: "/academic/wizklub/add-daily-target",
  editWizklubDailyTarget: "/academic/wizklub/edit-daily-target",
  wizklubTrainerCallLogs: "/academic/wizklub/trainer-call-logs",
  wizklubTrainerDashboard: "/academic/wizklub/trainer-dashboard",
  wizklubTrainerAssignmentToManager: "/academic/wizklub/trainer-assignment-to-manager",
  addWizklubTrainerAssignmentToManager: "/academic/wizklub/add-trainer-assignment-to-manager",
  EditWizklubTrainerAssignmentToManager: "/academic/wizklub/edit-trainer-assignment-to-manager",
  employeeDashboard: "/academic/employee/dashobard",


  // Wizklub
  studentData: "/academic/wizklub/student-data",
  // User Management
  addGroup: "/academic/add-group",
  editGroup: "/academic/edit-group",
  groups: "/academic/groups",
  users: "/academic/users",
  addUser: "/academic/add-user",
  editUser: "/academic/edit-user",
  userProfile: "/academic/user-profile",
  // dashboard routes
  adminDashboard: "/academic/summerCamp/dashboard",
  parentDashboard: "/parent-dashboard",
  studentDashboard: "/student-dashboard",
  teacherDashboard: "/teacher-dashboard",

  blankPage: "/blank-page",
  calendar: "/calendar",
  dataTables: "/data-tables",
  tablesBasic: "/tables-basic",
  notes: "/notes",
  comingSoon: "/coming-soon",

  // auth routes routes
  login: "/login-1",
  login2: "/login",
  login3: "/login-3",
  register: "/register",
  register2: "/register-2",
  register3: "/register-3",
  forgotPassword: "/forgot-password",
  forgotPassword2: "/forgot-password-2",
  forgotPassword3: "/forgot-password-3",
  twoStepVerification: "/two-step-verification",
  twoStepVerification2: "/two-step-verification-2",
  twoStepVerification3: "/two-step-verification-3",
  success: "/success",
  emailVerification: "/email-verification",
  emailVerification2: "/email-verification-2",
  emailVerification3: "/email-verification-3",
  lockScreen: "/lock-screen",
  resetPassword: "/reset-password",
  resetPassword2: "/reset-password-2",
  resetPassword3: "/reset-password-3",
  resetPasswordSuccess: "/reset-password-success",
  resetPasswordSuccess2: "/reset-password-success-2",
  resetPasswordSuccess3: "/reset-password-success-3",

  //ui routes
  alert: "/ui-alert",
  accordion: "/ui-accordion",
  avatar: "/ui-avatar",
  badges: "/ui-badges",
  border: "/ui-border",
  breadcrums: "/ui-breadcrums",
  button: "/ui-buttons",
  buttonGroup: "/ui-button-group",
  cards: "/ui-cards",
  carousel: "/ui-carousel",
  colors: "/ui-colors",
  dropdowns: "/ui-dropdowns",
  grid: "/ui-grid",
  images: "/ui-images",
  lightbox: "/ui-lightbox",
  media: "/ui-media",
  modals: "/ui-modals",
  navTabs: "/ui-navtabs",
  offcanvas: "/ui-offcanvas",
  pagination: "/ui-pagination",
  placeholder: "/ui-placeholder",
  popover: "/ui-popover",
  progress: "/ui-progress",
  rangeSlider: "/ui-rangeslider",
  spinner: "/ui-spinner",
  sweetalert: "/sweetalert",
  toasts: "/ui-toasts",
  tooltip: "/ui-tooltip",
  typography: "/ui-typography",
  video: "/ui-video",
  clipboard: "/ui-clipboard",
  counter: "/ui-counter",
  dragandDrop: "/ui-drag-drop",
  rating: "/ui-rating",
  ribbon: "/ui-ribbon",
  stickyNotes: "/ui-sticky-notes",
  textEditor: "/ui-text-editor",
  timeLine: "/ui-timeline",
  scrollBar: "/ui-scrollbar",
  apexChat: "/ui-apexchat",
  chart: "/ui-chartjs",
  featherIcons: "/ui-feather-icon",
  falgIcons: "/ui-flag-icon",
  fantawesome: "/ui-fantawesome",
  materialIcon: "/ui-material-icon",
  pe7icon: "/ui-icon-pe7",
  simpleLineIcon: "/ui-simpleline",
  themifyIcon: "/ui-themify",
  typicon: "/ui-typicon",
  weatherIcon: "/ui-weather-icon",
  basicInput: "/forms-basic-input",
  checkboxandRadion: "/form-checkbox-radios",
  inputGroup: "/form-input-groups",
  gridandGutters: "/form-grid-gutters",
  formSelect: "/form-select",
  formMask: "/form-mask",
  fileUpload: "/form-fileupload",
  horizontalForm: "/form-horizontal",
  verticalForm: "/form-vertical",
  floatingLable: "/form-floating-labels",
  formValidation: "/form-validation",
  reactSelect: "/select",
  formWizard: "/form-wizard",
  dataTable: "/tables-basic",
  tableBasic: "/data-tables",
  iconicIcon: "/icon-ionic",

  //base-ui
  uiAlerts: "/ui-alerts",
  uiAccordion: "/ui-accordion",
  uiAvatar: "/ui-avatar",
  uiBadges: "/ui-badges",
  uiBorders: "/ui-borders",
  uiButtons: "/ui-buttons",
  uiButtonsGroup: "/ui-buttons-group",
  uiBreadcrumb: "/ui-breadcrumb",
  uiCards: "/ui-cards",
  uiCarousel: "/ui-carousel",
  uiColor: "/ui-color",
  uiDropdowns: "ui-dropdowns",

  // pages routes
  error404: "/error-404",
  error500: "/error-500",
  underMaintenance: "/under-maintenance",

  // settings routes
  customFields: "/app-settings/custom-fields",
  invoiceSettings: "/app-settings/invoice-settings",

  bankAccount: "/financial-settings/bank-ccount",
  paymentGateways: "/financial-settings/payment-gateways",
  taxRates: "/financial-settings/tax-rates",

  schoolSettings: "/academic-settings/school-settings",
  religion: "/academic-settings/religion",

  connectedApps: "/general-settings/connected-apps",
  notificationssettings: "/general-settings/notifications-settings",
  profilesettings: "/general-settings/profile-settings",
  securitysettings: "/general-settings/security-settings",

  banIpAddress: "/other-settings/ban-ip-address",
  storage: "/other-settings/storage",

  emailSettings: "/system-settings/email-settings",
  emailTemplates: "/system-settings/email-templates",
  gdprCookies: "/system-settings/gdpr-cookies",
  smsSettings: "/system-settings/sms-settings",
  optSettings: "/system-settings/otp-settings",

  socialAuthentication: "/website-settings/social-authentication",
  companySettings: "/website-settings/company-settings",
  language: "/website-settings/language",
  localization: "/website-settings/localization",
  preference: "/website-settings/preference",
  prefixes: "/website-settings/prefixes",

  // application routes
  todo: "/application/todo",
  email: "/application/email",
  videoCall: "/application/video-call",
  chat: "/application/chat",
  audioCall: "/application/audio-call",
  callHistory: "/application/call-history",
  fileManager: "/application/file-manager",

  //content routes
  pages: "/content/pages",
  cities: "/content/cities",
  states: "/content/states",
  testimonials: "/content/testimonials",
  countries: "/content/countries",
  faq: "/content/faq",
  // blog
  allBlogs: "/content/all-blogs",
  blogCategories: "/content/blog-categories",
  blogComments: "/content/blog-comments",
  blogTags: "/content/blog-tags",

  //userManagement routes
  deleteRequest: "/user-management/delete-request",
  rolesPermissions: "/user-management/roles-permissions",
  manageusers: "/user-management/manage-users",
  permissions: "/user-management/permissions",

  //support routes
  contactMessages: "/support/contact-messages",
  tickets: "/support/tickets",
  ticketGrid: "/support/ticket-grid",
  ticketDetails: "/support/ticket-details",

  // membership routes
  membershipplan: "/membership-plans",
  membershipAddon: "/membership-addons",
  membershipTransaction: "/membership-transactions",

  // Peoples Module
  studentGrid: "/student/student-grid",
  studentPromotion: "/student/student-promotion",
  studentDetail: "/student/student-details",
  studentTimeTable: "/student/student-time-table",
  studentLeaves: "/student/student-leaves",
  studentFees: "/student/student-fees",
  studentResult: "/student/student-result",
  studentLibrary: "/student/student-library",
  studentList: "/student/student-list",
  addStudent: "/student/add-student",
  editStudent: "/student/edit-student",
  teacherDetails: "/teacher/teacher-details",
  teacherGrid: "/teacher/teacher-grid",
  teacherList: "/teacher/teacher-list",
  addTeacher: "/teacher/add-teacher",
  editTeacher: "/teacher/edit-teacher",
  teacherLibrary: "/teacher/teacher-library",
  teacherSalary: "/teacher/teacher-salary",
  teacherLeaves: "/teacher/teacher-leaves",
  teachersRoutine: "/teacher/teacher-routine",
  parentGrid: "/parent/parent-grid",
  parentList: "/parent/parent-list",
  guardiansGrid: "/parent/guardians-grid",
  guardiansList: "/parent/guardians-list",

  // Management
  feesGroup: "/management/fees-group",
  feesType: "/management/fees-type",
  feesMaster: "/management/fees-master",
  feesAssign: "/management/fees-assign",
  collectFees: "/management/collect-fees",
  libraryMembers: "/management/library-members",
  libraryIssueBook: "/management/library-issue-book",
  libraryBooks: "/management/library-books",
  libraryReturn: "/management/library-return",
  playerList: "/management/players",
  sportsList: "/management/sports",
  hostelList: "/management/hostel-list",
  hostelType: "/management/hostel-type",
  hostelRoom: "/management/hostel-rooms",
  transportAssignVehicle: "/management/transport-assign-vehicle",
  transportVehicle: "/management/transport-vehicle",
  transportVehicleDrivers: "/management/transport-vehicle-drivers",
  transportPickupPoints: "/management/transport-pickup-points",
  transportRoutes: "/management/transport-routes",

  //Academic module
  AcademicReason: "/academic/academic-reason",
  classSyllabus: "/academic/class-syllabus",
  classSubject: "/academic/class-subject",
  classSection: "/academic/class-section",
  classRoom: "/academic/class-room",
  classRoutine: "/academic/class-routine",
  sheduleClasses: "/academic/schedule-classes",
  classes: "/academic/classes",
  classHomeWork: "/academic/class-home-work",
  exam: "/academic/exam",
  examSchedule: "/academic/exam-schedule",
  grade: "/academic/grade",
  examResult: "/academic/exam-result",
  examAttendance: "/academic/exam-attendance",
  classTimetable: "/academic/class-time-table",

  //Hrm module
  staff: "/hrm/staff",
  departments: "/hrm/departments",
  payroll: "/hrm/payroll",
  holidays: "/hrm/holidays",
  designation: "/hrm/designation",
  listLeaves: "/hrm/list-leaves",
  staffDetails: "/hrm/staff-details",
  staffPayroll: "/hrm/staff-payroll",
  staffLeave: "/hrm/staff-leave",

  approveRequest: "/hrm/approve-request",
  studentAttendance: "/hrm/student-attendance",
  teacherAttendance: "/hrm/teacher-attendance",
  staffAttendance: "/hrm/staff-attendance",
  addStaff: "/hrm/add-staff",
  editStaff: "/hrm/edit-staff",
  staffsAttendance: "/hrm/staffs-attendance",

  layoutDefault: "/layout-default",
  layoutMini: "/layout-mini",
  layoutRtl: "/layout-rtl",
  layoutBox: "/layout-box",
  layoutDark: "/layout-dark",

  // finance & accounts routes
  accountsIncome: "/accounts/accounts-income",
  accountsInvoices: "/accounts/accounts-invoices",
  accountsTransactions: "/accounts/accounts-transactions",
  expense: "/accounts/expense",
  expenseCategory: "/accounts/expense-category",
  invoice: "/accounts/invoice",
  addInvoice: "/accounts/add-invoice",
  editInvoice: "/accounts/edit-invoice",

  // announcements routes
  events: "/announcements/events",
  noticeBoard: "/announcements/notice-board",

  //Report
  attendanceReport: "/report/attendance-report",
  classReport: "/report/class-report",
  studentReport: "/report/student-report",
  gradeReport: "/report/grade-report",
  leaveReport: "/report/leave-report",
  feesReport: "/report/fees-report",
  teacherReport: "/report/teacher-report",
  staffReport: "/report/staff-report",
  studentAttendanceType: "/report/student-attendance-type",
  dailyAttendance: "/report/daily-attendance",
  studentDayWise: "/report/student-day-wise",
  teacherDayWise: "/report/teacher-day-wise",
  staffDayWise: "/report/staff-day-wise",
  //page module
};
